import {
  handleValidDate,
  handleValidTime,
  usdFormatter
} from '../../../helpers/helpers';
import PackageOrdersActions from './actions';

export const columns = [
  {
    id: 1,
    Header: 'Golden Card ID',
    accessor: 'id',
    Cell: (cell: any) => {
      return cell?.value;
    }
  },
  {
    id: 2,
    Header: 'User ID',
    accessor: 'user',
    Cell: (cell: any) => {
      return cell.value.id;
    }
  },

  {
    id: 3,
    Header: 'User',
    accessor: 'user',
    Cell: (cell: any) => {
      return (
        <>
          {cell.value.name} {cell.value.surname}
        </>
      );
    }
  },
  {
    id: 4,
    Header: 'Price',
    accessor: 'package',
    Cell: (cell: any) => {
      return cell.row.original.price
        ? usdFormatter.format(cell.row.original.price)
        : '---';
    }
  },

  {
    id: 5,
    Header: 'Price + VAT + FEE',
    accessor: 'price',
    Cell: (cell: any) => {
      return cell?.row?.original?.orderPayments[0]?.amount
        ? usdFormatter.format(cell?.row?.original?.orderPayments[0]?.amount)
        : '---';
    }
  },

  {
    id: 6,
    Header: 'Order Date',
    accessor: 'dateCreated',
    Cell: (cell: any) => (
      <>
        {handleValidDate(cell.row.original.dateCreated)},
        <small className='text-muted'>
          {' '}
          {handleValidTime(cell.row.original.dateCreated)}
        </small>
      </>
    )
  },

  {
    id: 7,
    Header: 'Payment Date',
    accessor: 'datePaid',
    Cell: (cell: any) => {
      if (cell.value) {
        return (
          <>
            {handleValidDate(cell.value)},
            <small className='text-muted'> {handleValidTime(cell.value)}</small>
          </>
        );
      }
    }
  },
  {
    id: 8,
    Header: 'Status',
    accessor: 'status',
    Cell: (cell: any) => {
      switch (cell.value) {
        case 1:
          return (
            <span className='badge text-uppercase badge-soft-warning'>
              PENDING
            </span>
          );

        case 2:
          return (
            <span className='badge text-uppercase badge-soft-success'>
              PAID
            </span>
          );

        case 3:
          return (
            <span className='badge text-uppercase badge-soft-danger'>
              CANCELED
            </span>
          );

        case 4:
          return (
            <span className='badge text-uppercase badge-soft-danger'>
              CANCELED BY USER
            </span>
          );
      }
    }
  },

  {
    id: 9,
    Header: 'Actions',
    accessor: 'id',
    Cell: (cell: any) => {
      if (cell?.row?.original?.status === 1) {
        return <PackageOrdersActions {...cell} />;
      }
    }
  }
];
